import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthSessionService } from '../../core/services/auth-session.service';
import { isDistributorSupervisorAccess } from '../utils/access';

export const authGuard: CanActivateFn = () => {
  const authSession = inject(AuthSessionService);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  if (!authSession.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  const user = authSession.session()?.user;
  if (!isDistributorSupervisorAccess(user)) {
    authSession.clearSession();
    snackBar.open('Недостаточно прав для входа', undefined, { duration: 4000 });
    return router.createUrlTree(['/login']);
  }

  return true;
};

export const guestGuard: CanActivateFn = () => {
  const authSession = inject(AuthSessionService);
  const router = inject(Router);

  if (!authSession.isAuthenticated()) {
    return true;
  }

  if (!isDistributorSupervisorAccess(authSession.session()?.user)) {
    authSession.clearSession();
    return true;
  }

  return router.createUrlTree(['/home']);
};
